import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=7905e724"
import script from "./page-header.ts?vue&type=script&lang=ts&external"
export * from "./page-header.ts?vue&type=script&lang=ts&external"
import style0 from "./page-header.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports